export default __webpack_public_path__ + "static/media/misc-pantry1-1440w.90ac6f01.avif";